import React from 'react';
import OrderList from '../common/OrderList';
import { purchaseOrdersAPI } from '../../services/api';
import { Receipt } from 'lucide-react';

export default function PurchaseOrders() {
  return (
    <OrderList
      title="Purchase Orders"
      icon="📦"
      api={purchaseOrdersAPI}
      basePath="/purchase-orders"
      statuses={['Draft', 'Submitted', 'PartiallyReceived', 'Received', 'Closed', 'Cancelled']}
      numberField="po_number"
      partyField="vendor_name"
      dateField="order_date"
      secondField="expected_date"
      secondLabel="Expected"
      reopenAPI={(id) => purchaseOrdersAPI.reopen(id)}
      convertActions={[
        { label: 'Bill', icon: <Receipt size={12} />, handler: (id) => purchaseOrdersAPI.convertToBill(id), redirectTo: (billId) => `/bills/${billId}` },
      ]}
    />
  );
}
